<template>
  <ul class="tab-selector">
    <li class="tab-selector-item" v-for="(tab, key) in tabsData">
      <button type="button"
              ref="tab-button"
              class="tab-button"
              v-bind:class="{first: key === 0, last: key === lastIndex, active: key === activeIndex}"
              v-bind:name="tab.id"
              v-on:click="changeActive(tab.id, key)">
        {{tab.label}}<number-icon v-if="tab.counter" :value="tab.counter"></number-icon>
        <!-- <ui-ripple-ink trigger="tab-button"></ui-ripple-ink> -->
      </button>
    </li>
  </ul>
</template>

<script>
  import NumberIcon from 'components/NumberIcon'

  export default {
    name: 'tab-selector',
    data () {
      return {
        activeIndex: 0
      }
    },
    props: {
      tabsData: {
        default: function () {
          return []
        }
      }
    },
    computed: {
      lastIndex () {
        return this.tabsData.length - 1
      }
    },
    methods: {
      changeActive (tabId, index) {
        this.activeIndex = index
        this.$emit('change', tabId)
      }
    },
    components: {
      'number-icon': NumberIcon
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';

  .tab-selector {
    display: inline-block;
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: center;

    li.tab-selector-item {
      display: inline;
    }

    button.tab-button {
      position: relative;
      height: 35px;
      line-height: 35px;
      font-size: 10px;
      text-transform: uppercase;
      font-weight: bold;
      padding: 0 10px;
      background-color: white;
      border-top: 1px solid $grey-50;
      border-bottom: 1px solid $grey-50;
      border-right: 1px solid $grey-50;

      &.first {
        border-left: 1px solid #d7d7d7;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }

      &.last {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }

      &:hover,
      &.active {
        background-color: $somfy;
        color: #ffffff;
      }

      .number-icon {
        margin-left: 3px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// TabSelector.vue?945a893a